import React, { useEffect, useState } from "react";

export const Lightbox = ({ imgSrc, ...rest }) => {
  const [show, setShow] = useState(false);
  const cover = document.getElementById("cover");

  const toggleShow = () => setShow((show) => !show);

  useEffect(() => {
    if (show) {
      const coverEl = document.createElement("div");
      coverEl.id = "cover";
      coverEl.addEventListener("click", toggleShow);
      coverEl.innerHTML = `<img class='lgthbox-image' src='${imgSrc}' />`;

      document.body.appendChild(coverEl);
    } else {
      if (cover) {
        document.body.removeChild(cover);
      }
    }
    // eslint-disable-next-line
  }, [show, imgSrc]);

  return (
    <img
      {...rest}
      style={{ cursor: "pointer" }}
      onClick={toggleShow}
      src={imgSrc}
      alt=""
    />
  );
};
